/* LOST iN new home: live stories feed from the WordPress REST API.
 * Fills the .lpg block (1 feature + 3 cards) with the newest posts.
 * The server-rendered markup stays as the fallback if the fetch fails. */
(function () {
  'use strict';
  var root = document.querySelector('.lpg[data-lnh-wp]');
  if (!root) return;
  setTimeout(function () { root.classList.add('lnh-ready'); }, 3000);
  var base = root.getAttribute('data-lnh-wp').replace(/\/+$/, '');
  if (!base) return;

  function text(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return (d.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function clip(s, n) { return s.length > n ? s.slice(0, n).replace(/\s+\S*$/, '') + '…' : s; }
  function cats(p) {
    var terms = (p._embedded && p._embedded['wp:term']) || [];
    var out = [];
    terms.forEach(function (g) { (g || []).forEach(function (t) { if (t.taxonomy === 'category' && t.name !== 'Uncategorized') out.push(t.name); }); });
    return out.join(' • ');
  }
  function terms(p, tax) {
    var groups = (p._embedded && p._embedded['wp:term']) || [], out = [];
    groups.forEach(function (g) { (g || []).forEach(function (t) { if (t.taxonomy === tax) out.push(t.name); }); });
    return out;
  }
  /* "City, Country" from the post's city/country taxonomies; country alone when no city is set. */
  function place(p) {
    var city = terms(p, 'city').join(' / '), country = terms(p, 'country')[0] || '';
    if (city && country) return city + ', ' + country;
    return city || country;
  }
  function img(p) {
    var m = p._embedded && p._embedded['wp:featuredmedia'] && p._embedded['wp:featuredmedia'][0];
    if (!m) return null;
    var s = (m.media_details && m.media_details.sizes) || {};
    var pick = s['1536x1536'] || s.large || s.medium_large || {};
    return { src: pick.source_url || m.source_url, alt: m.alt_text || text(p.title.rendered) };
  }
  function date(p) {
    return new Date(p.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  /* Per-story look from WordPress (lostin-home-card plugin): Solid color or Photo, set on the post. */
  function look(el, p, isMain) { var m = p.meta || {}; if (m.lostin_card_mode !== 'solid' && m.lostin_card_mode !== 'photo') return; var bg = m.lostin_card_bg || '#111111', fg = m.lostin_card_text || '#ffffff', d = Math.max(0, Math.min(90, parseInt(m.lostin_card_dark, 10) || 0)) / 100, photo = m.lostin_card_mode === 'photo'; var texts = el.querySelectorAll(isMain ? '.lpg-main-title, .lpg-main-title a, .lnh-main-meta, .lpg-main-excerpt p, .lpg-cat' : '.lpg-card-link, .lpg-cat, .lpg-card-title, .lpg-card-date, .lpg-card-excerpt'); Array.prototype.forEach.call(texts, function (t) { t.style.color = fg; }); if (isMain) { var media = el.querySelector('.lpg-main-media'), pic = media && media.querySelector(':scope > img'), over = el.querySelector('.lnh-main-over'); if (!media) return; media.style.background = bg; if (pic) pic.style.display = photo ? '' : 'none'; if (over) over.style.background = photo ? 'linear-gradient(to top, rgba(0,0,0,' + Math.min(0.95, d + 0.4) + ') 0%, rgba(0,0,0,' + Math.min(0.6, d + 0.1) + ') 45%, rgba(0,0,0,0) 100%)' : 'none'; return; } var im = img(p); el.style.background = photo && im ? 'linear-gradient(rgba(0,0,0,' + d + '), rgba(0,0,0,' + d + ')), url(' + JSON.stringify(im.src) + ') center / cover no-repeat, ' + bg : bg; }
  function setCats(el, value) {
    if (!el) return;
    el.innerHTML = '';
    if (!value) { el.style.display = 'none'; return; }
    var span = document.createElement('span');
    span.className = 'lpg-cat';
    span.textContent = value;
    el.appendChild(span);
  }

  fetch(base + '/wp-json/wp/v2/posts?per_page=4&_embed=wp:featuredmedia,wp:term', { credentials: 'omit' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (posts) {
      if (!posts || !posts.length) return;
      var main = root.querySelector('.lpg-main');
      var p = posts[0];
      if (main) {
        var title = text(p.title.rendered), ex = text(p.excerpt.rendered);
        var a = main.querySelector('.lpg-main-title a');
        if (a) { a.textContent = title; a.href = p.link; }
        var im = img(p), tag = main.querySelector('.lpg-main-media img');
        if (im && tag) { tag.src = im.src; tag.alt = im.alt; tag.removeAttribute('srcset'); }
        setCats(main.querySelector('.lpg-cats'), cats(p));
        var sum = main.querySelector('.lpg-main-summary p');
        if (sum) sum.textContent = '“' + clip(ex, 220) + '”';
        var meta = main.querySelector('.lnh-main-meta');
        if (meta) {
          var loc = place(p);
          meta.textContent = (loc ? loc + ' \u00B7 ' : '') + date(p);
          meta.setAttribute('datetime', p.date);
        }
        var exP = main.querySelector('.lpg-main-excerpt p');
        if (exP) exP.textContent = clip(ex, 130);
        var btn = main.querySelector('.lpg-btn');
        if (btn) btn.setAttribute('href', p.link);
        var hit = main.querySelector('.lnh-main-hit');
        if (hit) hit.setAttribute('href', p.link);
        look(main, p, true);
      }
      var cards = root.querySelectorAll('.lpg-card');
      Array.prototype.forEach.call(cards, function (card, i) {
        var q = posts[i + 1];
        if (!q) { card.style.display = 'none'; return; }
        var link = card.querySelector('.lpg-card-link');
        if (link) link.href = q.link;
        var t = card.querySelector('.lpg-card-title');
        if (t) t.textContent = text(q.title.rendered);
        var d = card.querySelector('.lpg-card-date');
        if (d) { var loc = place(q); d.textContent = (loc ? loc + ' \u00B7 ' : '') + date(q); d.setAttribute('datetime', q.date); }
        var e = card.querySelector('.lpg-card-excerpt');
        if (e) e.textContent = clip(text(q.excerpt.rendered), 140);
        setCats(card.querySelector('.lpg-cats'), cats(q));
        look(card, q, false);
      });
      root.setAttribute('data-lnh-live', '1');
      root.classList.add('lnh-ready');
    })
    .catch(function () { root.classList.add('lnh-ready'); /* keep the server-rendered fallback */ });
})();
